import { ReactComponent as InfoIconFile } from 'assets/icons/justificativa-icon.svg'

import { IconStyles } from '../types'
import { InfoIconCustom } from './styles'

interface UploadProps extends IconStyles {
  onClick?: any
  filter?: boolean
  disabled?: boolean
}

const InfoIcon = ({
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon,
  disabled
}: UploadProps) => {
  return (
    <InfoIconCustom
      disabled={disabled}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={disabled ? null : onClick}
      colorIcon={colorIcon}
    >
      <InfoIconFile />
    </InfoIconCustom>
  )
}

export default InfoIcon
